import React from 'react'
import { Link } from 'react-router-dom'

import { Consultant } from '../queries'
import styles from '../styles.module.scss'

interface ClinicianCellProps {
  clinicianUuid: string
  getClinician: (uuid: string) => Consultant | undefined
}

const ClinicianCell = ({ clinicianUuid, getClinician }: ClinicianCellProps) => {
  const clinician = clinicianUuid ? getClinician(clinicianUuid) : undefined
  if (!clinician?.full_name) return null

  const name = clinician.full_name

  return clinician.id ? (
    <Link
      to={`/admin/consultants/${clinician.id}`}
      className={styles.profileLink}
      onClick={(e) => e.stopPropagation()}
    >
      {name}
    </Link>
  ) : (
    <>{name}</>
  )
}

export default ClinicianCell
